'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstTableRow = function (_VstComponent) {
  _inherits(VstTableRow, _VstComponent);

  function VstTableRow() {
    _classCallCheck(this, VstTableRow);

    return _possibleConstructorReturn(this, (VstTableRow.__proto__ || Object.getPrototypeOf(VstTableRow)).apply(this, arguments));
  }

  _createClass(VstTableRow, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'tr',
        {
          style: { cursor: this.props.onClick ? 'pointer' : '' },
          onClick: this.props.onClick,
          tabIndex: 0
        },
        this.props.children,
        _react2.default.createElement(
          'td',
          {
            className: 'vst-table-col-hidden'
          },
          this.props.onClick && _react2.default.createElement(
            'button',
            { tabIndex: '-1', onClick: this.props.onClick },
            'Select'
          )
        )
      );
    }
  }]);

  return VstTableRow;
}(_VstComponent3.default);

exports.default = VstTableRow;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstTableRow.js
 **/